import React, { Component } from 'react';
import * as _ from 'lodash';
import { Checkbox, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';

import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { TransactionSummaryEnum } from 'Common/FieldEnum';
import ReactTable from 'Common/ReactTableWrapper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { dateSortMethod } from 'Common/GridHelper';

class TransactionSummaryGridContainer extends Component {
  columns = [
    {
      Header: currentRows => {
        const { input } = this.props;
        const dataObjs = currentRows.data;
        let filteredData = [];
        let checkAllIds = [];
        _.forEach(dataObjs, obj => {
          const id = obj[TransactionSummaryEnum.Id]
            ? obj[TransactionSummaryEnum.Id]
            : obj._original[TransactionSummaryEnum.Id];
          if (input.value.indexOf(id) === -1) {
            filteredData.push(id);
          } else {
            checkAllIds.push(id);
          }
        });

        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={
                dataObjs.length > 0 && checkAllIds.length === dataObjs.length
              }
              onChange={(e, { checked }) => {
                e.stopPropagation();
                if (checked) {
                  input.onChange([...filteredData, ...input.value]);
                } else {
                  const copySelected = [...filteredData, ...input.value];
                  _.forEach(dataObjs, obj => {
                    const id = obj[TransactionSummaryEnum.Id]
                      ? obj[TransactionSummaryEnum.Id]
                      : obj._original[TransactionSummaryEnum.Id];
                    const index = copySelected.indexOf(id);
                    if (index !== -1) {
                      copySelected.splice(index, 1);
                    }
                  });
                  input.onChange(copySelected);
                }
              }}
            />
          </div>
        );
      },
      accessor: 'Allowed',
      ...ReactTableWrapperColumnProperties,
      sortable: false,
      filterable: false,
      Cell: ({ original }) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={
                this.props.input.value.indexOf(
                  original[TransactionSummaryEnum.Id]
                ) !== -1
              }
              onChange={(e, { checked }) => {
                this.checkCurrentRow(original, checked);
              }}
            />
          </div>
        );
      },
    },
    {
      Header: 'Begin Date',
      accessor: TransactionSummaryEnum.BeginDT,
      ...ReactTableWrapperColumnProperties,
      sortMethod: dateSortMethod,
    },
    {
      Header: 'End Date',
      accessor: TransactionSummaryEnum.EndDT,
      ...ReactTableWrapperColumnProperties,
      sortMethod: dateSortMethod,
    },
  ];
  checkCurrentRow = (original, checked) => {
    const { input } = this.props;
    let value = [...input.value];
    checked
      ? value.indexOf(original[TransactionSummaryEnum.Id]) === -1 &&
        value.push(original[TransactionSummaryEnum.Id])
      : value.indexOf(original[TransactionSummaryEnum.Id]) !== -1 &&
        value.splice(value.indexOf(original[TransactionSummaryEnum.Id]), 1);

    input.onChange(value);
  };

  render() {
    const {
      data,
      loading,
      setReactTableWrapperInstance,
      reactTableRef,
    } = this.props;
    return (
      <Form.Field>
        <ReactTable
          defaultPageSize={20}
          showPageSizeOptions={true}
          minRows={0}
          data={data}
          noDatatext={'No rows found'}
          resizable={false}
          className="-striped -highlight"
          columns={this.columns}
          loading={loading}
          saveState={{
            tableName: TableNamesEnum.TRANSACTION_SUMMARY_DETAIL_TABLE,
          }}
          menu={false}
          onRef={setReactTableWrapperInstance}
          reactTableRef={reactTableRef}
        />
      </Form.Field>
    );
  }
}
const mapStateToProps = state => {
  return {
    allTableStates: getTableStates(state),
  };
};
export default connect(
  mapStateToProps,
  null
)(TransactionSummaryGridContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/containers/transactionSummaryList/TransactionSummaryGridContainer.js